export default __webpack_public_path__ + "static/media/game3.077d31af.webp";